module.exports = __webpack_public_path__ + "media/newstyle/images/youtube-play-svgrepo-com-c375e95b9b5b083f80a8eb9828855740.svg";